import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_DOMAIN_MULTI_ANCHOR: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateDomainMultianchor(
    $input: UpdateDomainRichPlacementMultianchorConfigurationInput!
  ) {
    updateDomainRichPlacementMultianchorConfiguration(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
